/**
 * Converts numeric value to css string value with unit
 * @param {string|number} value
 * @param {string} unit
 */
export function toPixels(value, unit = "px") {
    if (!String(value).endsWith(unit)) {
        value = String(value) + unit;
    }

    return value;

}


/**
 * Parses string with pixel value to number
 * @param {number|string} value The value to parse
 * @param {string} unit Optional unit, defaults to px
 * @returns {number|*}
 */
export function fromPixels(value, unit = "px") {
    if (typeof value !== "string") {
        return value;
    }

    const pattern = new RegExp(`${unit}$`);
    return parseFloat(value.replace(pattern, ""));
}
